module.exports = __webpack_public_path__ + "img/webnew06.72c66735.png";